module.exports = __webpack_public_path__ + "img/hero-photo-4.7f924a9f.jpg";